// Toast tối giản: một kho ngoài React + useSyncExternalStore — gọi được từ bất cứ đâu (kể cả ngoài component).
import { useSyncExternalStore } from 'react';

// `nut`: một nút hành động trên toast (vd "Hoàn tác") — bấm thì toast đóng rồi chạy `lam`.
export type MucThongBao = { id: number; noi_dung: string; kieu: 'thuong' | 'loi'; nut?: { nhan: string; mo_ta?: string; lam: () => void } };

let ds: MucThongBao[] = [];
let dem = 0;
const nghe = new Set<() => void>();
const phat = () => nghe.forEach((f) => f());

export function thongBao(
  noi_dung: string,
  kieu: MucThongBao['kieu'] = 'thuong',
  tuy_chon?: { nut?: MucThongBao['nut']; ms?: number },
): number {
  const id = ++dem;
  ds = [...ds, { id, noi_dung, kieu, ...(tuy_chon?.nut ? { nut: tuy_chon.nut } : {}) }];
  phat();
  setTimeout(() => boThongBao(id), tuy_chon?.ms ?? (kieu === 'loi' ? 8000 : 3500));
  return id;
}

export function boThongBao(id: number) {
  if (!ds.some((m) => m.id === id)) return;
  ds = ds.filter((m) => m.id !== id);
  phat();
}

export function useThongBao() {
  return useSyncExternalStore(
    (f) => {
      nghe.add(f);
      return () => nghe.delete(f);
    },
    () => ds,
  );
}
